import { Spec } from '../proto/common.js';
import { DeathknightTalents, DeathknightMajorGlyph, DeathknightMinorGlyph } from '../proto/deathknight.js';
import { Player } from '../player.js';

import { GlyphsConfig } from './glyphs_picker.js';
import { TalentsConfig, newTalentsConfig } from './talents_picker.js';

import DkTalentsJson from './trees/deathknight.json';

export const deathknightTalentsConfig: TalentsConfig<DeathknightTalents> = newTalentsConfig(DkTalentsJson);

export const deathknightGlyphsConfig: GlyphsConfig = {
	majorGlyphs: {
		[DeathknightMajorGlyph.GlyphOfAntiMagicShell]: {
			name: '反魔法护罩雕文',
			description: '使你的反魔法护罩的持续时间延长2秒。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_antimagicshell.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfBloodStrike]: {
			name: '鲜血打击雕文',
			description: '你的鲜血打击对被诱捕的目标造成的伤害提高20%。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_deathstrike.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfBoneShield]: {
			name: '白骨之盾雕文',
			description: '为你的白骨之盾增加1次使用次数。',
			iconUrl: '/wotlk/assets/icons/inv_chest_leather_13.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfChainsOfIce]: {
			name: '寒冰锁链雕文',
			description: '你的寒冰锁链可以造成额外的144到156点冰霜伤害，这个数值受到你的攻击强度加成影响。',
			iconUrl: '/wotlk/assets/icons/spell_frost_chainsofice.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDancingRuneWeapon]: {
			name: '符文刃舞雕文',
			description: '符文刃舞的持续时间延长5秒。',
			iconUrl: '/wotlk/assets/icons/inv_sword_07.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDarkCommand]: {
			name: '黑暗命令雕文',
			description: '使你的黑暗命令技能的成功率提高8%。',
			iconUrl: '/wotlk/assets/icons/spell_nature_shamanrage.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDarkDeath]: {
			name: '黑暗死亡雕文',
			description: '死亡缠绕造成的伤害或治疗效果提高15%。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_deathcoil.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDeathAndDecay]: {
			name: '枯萎凋零雕文',
			description: '你的枯萎凋零法术造成的伤害提高20%。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_deathanddecay.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDeathGrip]: {
			name: '死亡之握雕文',
			description: '当你杀死一个可以提供经验值或荣誉值的目标时，你的死亡之握的冷却时间就会刷新。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_strangulate.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDeathStrike]: {
			name: '灵界打击雕文',
			description: '你的每1点符文能量值都可以使你的灵界打击造成的伤害提高1%（最多25%）。这个效果不会消耗符文能量值。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_butcher2.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfDisease]: {
			name: '疾病雕文',
			description: '你的传染技能可以使你的主要目标身上的疾病效果持续时间、疾病附加效果持续时间刷新到起始状态。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_plaguecloud.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfFrostStrike]: {
			name: '冰霜打击雕文',
			description: '你的冰霜打击消耗的符文能量值减少8点。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_empowerruneblade2.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfHeartStrike]: {
			name: '心脏打击雕文',
			description: '你的心脏打击将使目标的移动速度降低50%，持续10秒。',
			iconUrl: '/wotlk/assets/icons/inv_weapon_shortblade_40.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfHowlingBlast]: {
			name: '凛风冲击雕文',
			description: '你的凛风冲击技能可以使目标感染冰霜疫病。',
			iconUrl: '/wotlk/assets/icons/spell_frost_arcticwinds.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfHungeringCold]: {
			name: '饥饿之寒雕文',
			description: '饥饿之寒的符文能量值消耗降低40点。',
			iconUrl: '/wotlk/assets/icons/inv_staff_15.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfIceboundFortitude]: {
			name: '冰封之韧雕文',
			description: '无论你的防御技能值是多少，你的冰封之韧总是可以提供至少40%的伤害减免。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_iceboundfortitude.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfIcyTouch]: {
			name: '冰冷触摸雕文',
			description: '你的冰霜疫病造成20%的额外伤害。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_icetouch.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfObliterate]: {
			name: '湮没雕文',
			description: '你的湮没技能造成的伤害提高25%。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_classicon.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfPlagueStrike]: {
			name: '天灾打击雕文',
			description: '你的天灾打击会使目标身上的疾病效果延长3秒，最多额外延长9秒。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_empowerruneblade.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfRuneStrike]: {
			name: '符文打击雕文',
			description: '使你的符文打击技能的爆击几率提高10%。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_darkconviction.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfRuneTap]: {
			name: '符文分流雕文',
			description: '你的符文分流现在额外治疗你1%的最大生命值，而且还治疗你的小队10%的最大生命值。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_runetap.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfScourgeStrike]: {
			name: '暗影打击雕文',
			description: '你的暗影打击造成伤害提高20%。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_scourgestrike.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfStrangulate]: {
			name: '绞袭雕文',
			description: '使你的绞袭技能的冷却时间缩短20秒。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_soulleech_3.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfTheGhoul]: {
			name: '食尸鬼雕文',
			description: '使你的食尸鬼的力量值提高，数值相当于你的力量值的40%；你的食尸鬼的耐力值提高，数值相当于你的耐力值的40%。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_animatedead.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfUnbreakableArmor]: {
			name: '铜墙铁壁雕文',
			description: '从铜墙铁壁中所获得的护甲值提高30%。',
			iconUrl: '/wotlk/assets/icons/inv_armor_helm_plate_naxxramas_raidwarrior_c_01.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfUnholyBlight]: {
			name: '邪恶虫群雕文',
			description: '邪恶虫群伤害提高40%。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_contagion.jpg',
		},
		[DeathknightMajorGlyph.GlyphOfVampiricBlood]: {
			name: '吸血鬼之血雕文',
			description: '你的吸血鬼之血的持续时间延长5秒。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_lifedrain.jpg',
		},
	},
	minorGlyphs: {
		[DeathknightMinorGlyph.GlyphOfBloodTap]: {
			name: '鲜血之 tap雕文',
			description: '你的鲜血符文不再对你造成伤害。',
			iconUrl: '/wotlk/assets/icons/spell_deathknight_bloodtap.jpg',
		},
		[DeathknightMinorGlyph.GlyphOfCorpseExplosion]: {
			name: '尸体爆炸雕文',
			description: '使你的尸体爆炸技能的作用半径延长5码。',
			iconUrl: '/wotlk/assets/icons/ability_creature_disease_02.jpg',
		},
		[DeathknightMinorGlyph.GlyphOfDeathSEmbrace]: {
			name: '死亡拥抱雕文',
			description: '当你的死亡缠绕用于治疗时，返还20点符文能量值。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_deathcoil.jpg',
		},
		[DeathknightMinorGlyph.GlyphOfHornOfWinter]: {
			name: '寒冬号角雕文',
			description: '使你的寒冬号角的持续时间延长1分钟。',
			iconUrl: '/wotlk/assets/icons/inv_misc_horn_02.jpg',
		},
		[DeathknightMinorGlyph.GlyphOfPestilence]: {
			name: '疫病雕文',
			description: '使你的传染技能的作用半径延长5码。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_plaguecloud.jpg',
		},
		[DeathknightMinorGlyph.GlyphOfRaiseDead]: {
			name: '亡者复生雕文',
			description: '你的亡者复生法术不再需要施法材料。',
			iconUrl: '/wotlk/assets/icons/spell_shadow_animatedead.jpg',
		},
	},
};
